import { create, v, w } from '@dojo/framework/core/vdom';
// import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';

import { Keys } from '@holmescorp/common';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { keymap, pathmap, userstate } from '@holmescorp/lcc-state';
import { numeral } from '@holmescorp/numeral';

import css from '../css/topicgroup.m.css';

export interface QuizButtonProperties {
	topicid: string;
	text: string;
	fromtopic?: boolean;
	showscore?: boolean;
	showstatusicon?: boolean;
}

const factory = create({ theme, userstate }).properties<QuizButtonProperties>();

export const QuizButton = factory(({ properties, middleware: { theme, userstate } }) => {
	const themeCss = theme.classes(css);
	const { topicid, text, fromtopic = false, showscore = true, showstatusicon = false } = properties();
	const icon = `${window.hcstatic.portal_cdn}/js/images/iconsheet.svg#quiz`;
	const { get, path } = userstate;
	const status = get(path('status'));
	const [, , , topicroot] = keymap.get(topicid)!.path.split('/');
	const usetopic = fromtopic ? topicroot : topicid;
	const quizScore = status[usetopic] ? status[usetopic].data.percent : '';

	return v(
		'div',
		{
			classes: [themeCss.action],
			role: 'button',
			xqa: 'quiz-action-button',
			tabIndex: 0,
			onclick: (event) => {
				event && event.stopPropagation();
				const { path } = keymap.get(usetopic)!;
				const { view } = pathmap.get(`${path}/quiz`)!;
				view();
			},
			onkeydown: (event: KeyboardEvent) => {
				const { path } = keymap.get(usetopic)!;
				const { view } = pathmap.get(`${path}/quiz`)!;
				switch (event.key) {
					case Keys.Enter:
					case Keys.Space:
					case Keys.Spacebar:
						event.preventDefault();
						view();
				}
			}
		},
		[
			v('svg', { classes: [themeCss.actionIcon], 'xmlns:xlink': 'http://www.w3.org/1999/xlink' }, [
				v('use', {
					href: icon,
					'xlink:href': icon
				})
			]),
			showstatusicon ? w('TopicStatusIcon', { key: topicid, useQuizScore: false, quizCompleteOnly: true }) : null,
			quizScore && showscore
				? v('div', { classes: [themeCss.scorePill] }, [
						v('span', { classes: [themeCss.scoreLabel] }, [`${numeral(quizScore).format('0%')}`])
				  ])
				: null,
			v('div', { classes: [themeCss.actionText] }, [text])
		]
	);
});
